import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { IonBadge, IonIcon } from '@ionic/react'
import { ellipse, flash } from 'ionicons/icons'

import { ContestStatus } from '@enums'

export interface IStatusBadgeProps {
  status?: ContestStatus
  className?: string
}

export const StatusBadge: FC<IStatusBadgeProps> = ({
  status,
  className = '',
}) => {
  const { t } = useTranslation('common')

  let badgeState = {} as {
    color: 'danger' | 'success' | 'medium' | 'lightgreen'
    icon: string
    status: ContestStatus
  }

  switch (status) {
    case ContestStatus.Finished:
      badgeState = {
        color: 'danger',
        icon: ellipse,
        status,
      }
      break
    case ContestStatus.Submission:
      badgeState = {
        color: 'lightgreen',
        icon: flash,
        status,
      }
      break
    case ContestStatus.Started:
    case ContestStatus.Judging:
      badgeState = {
        color: 'success',
        icon: ellipse,
        status,
      }
      break
    default:
      badgeState = {
        color: 'success',
        icon: flash,
        status: ContestStatus.Voting,
      }
  }

  return (
    <span
      data-testid="status-badge"
      className={`inline-block mr-1 ${className}`}
    >
      <IonBadge
        color={badgeState.color}
        className="flex items-center flex-0 rounded-full p-0 px-0.5"
      >
        <IonIcon className="mr-1 w-3 h-3" icon={badgeState.icon} />
        <span className="uppercase text-xxs pr-1 leading-4">
          {t(`contest.details.status.${badgeState.status.toLowerCase()}`)}
        </span>
      </IonBadge>
    </span>
  )
}
